import axios from 'axios'
window.axios = axios
axios.defaults.baseURL = 'https://development-ferh-backend.herokuapp.com/api/v1.0'
//axios.defaults.baseURL = 'https://ferh-backend.herokuapp.com/api/v1.0'
//axios.defaults.baseURL = 'http://localhost:8081/api/v1.0'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';